import { createGlobalStyle } from 'styled-components'

const Global = createGlobalStyle`

* {
  margin: 1rem;
  padding: 0;
  font-family: 'poppins', sans-serif;
}

body {
  height: 100vh;
  display: flex;
  justify-content: center;
  background-color: #13072B
}
`

export default Global
